module.exports = __webpack_public_path__ + "static/img/default_list_bg.31bb878.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/default_list_bg.png
// module id = ORdg
// module chunks = 6